import { render, staticRenderFns } from "./DonutChart81.vue?vue&type=template&id=7a7c064c&scoped=true"
import script from "./DonutChart81.vue?vue&type=script&lang=js"
export * from "./DonutChart81.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7c064c",
  null
  
)

export default component.exports